import Meta from "../../components/custom-ui/meta/Meta";
import { requireAuth } from "../../providers/auth";
import AdminSeekerTab from "./AdminSeekerTabComponent/AdminSeekerTab";

function SeekersPage() {
  return (
    <div className="px-10 bg-gray-200  pt-36 py-6">
      <Meta title="Seekers" />
      <AdminSeekerTab />
    </div>
  );
}
export default requireAuth(SeekersPage);
